import React from 'react';
import { Form, Switch, Spin, Input, Tooltip, Select, Row, Col, Button, Upload, Icon, notification, InputNumber } from 'antd';
import { uploadAdsModalImage } from '../../modules/Api';
import { END_POINT } from '../../constants/config';

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AdsModalForm extends React.Component {
    constructor() {
        super();
        this.state = {
            link: "",
            alt: "",
            image: null,
            limit: 0,
            repeat: 0,
            delay: 0,
            status : 0,
        }
    }

    componentDidMount() {
        this.setState({
            link: "",
            alt: "",
            image: null,
            limit: 0,
            repeat: 0,
            delay: 0,
            status:0
        })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.initialData.image && this.state.image === null) {
            this.setState({ image: nextProps.initialData.image });
        }
        if (nextProps.initialData.limit && this.state.limit === null) {
            this.setState({ limit: nextProps.initialData.limit });
        }
        if (nextProps.initialData.repeat && this.state.repeat === null) {
            this.setState({ repeat: nextProps.initialData.repeat });
        }
        if (nextProps.initialData.delay && this.state.delay === null) {
            this.setState({ delay: nextProps.initialData.delay });
        }
        if (nextProps.initialData.link && this.state.link === "") {
            this.setState({ link: nextProps.initialData.link });
        }
        if (nextProps.initialData.alt && this.state.alt === "") {
            this.setState({ link: nextProps.initialData.alt });
        }
        if (nextProps.initialData.status && this.state.status === "") {
            this.setState({ status: nextProps.initialData.status });
        }
    }
    handleSubmit = e => {

        e.preventDefault();
        if (this.submittedAt > Date.now() - 500) {
            return;
        }
        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue, {
                image: this.state.image
            }));

        })
    }



    render() {
        let img = ""
        if (this.state.image != null) {
            img = <img src={`${this.state.image.includes('http') ? this.state.image : END_POINT + this.state.image}`}
                style={{ width: '50px', height: '50px', margin: '10px' }}
                alt="modal"
            />

        } else if (this.props.initialData.image != null) {
            img = <img src={`${this.props.initialData.image.includes('http') ? this.props.initialData.image : END_POINT + this.props.initialData.image}`}
                style={{ width: '50px', height: '50px', margin: '10px' }}
                alt="modal"
            />
        }
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{ direction: 'rtl' }}>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={9} offset={1}>
                            <FormItem
                                {...formItemLayout}
                                label="عکس تبلیغ"
                                extra="400 * 400 پیکسل"
                                colon={false}>
                                {getFieldDecorator('uploadImage', {
                                    initialValue: this.props.initialData.image ? this.props.initialData.image : null,

                                    valuePropName: 'fileListImage',
                                    getValueFromEvent: this.normFileImage,
                                })(
                                    <Upload
                                        name="image"
                                        action=""
                                        customRequest={() => { }}
                                        onChange={f => { uploadAdsModalImage(f, (src) => { this.setState({ image: src }) }) }}
                                        listType="picture"
                                        showUploadList={false}>
                                        <Button>
                                            <Icon type="upload" /> انتخاب فایل
                                        </Button>
                                        <br />
                                        {img}
                                    </Upload>
                                )}
                            </FormItem>
                        </Col>

                        <Col span={11} offset={1}>


                            <FormItem
                                {...formItemLayout}
                                label={"لینک"}
                                colon={true} >
                                {getFieldDecorator('link', {
                                    initialValue: this.props.initialData.link ? this.props.initialData.link : null,
                                    rules: [{
                                        required: true,
                                        message: 'لینک مودال: ',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>


                    </Row>
                    <Row>
                        
                        <Col span={6} offset={5}>
                            <Form.Item
                                {...formItemLayout}
                                label="تاخیر در نمایش (بر حسب ثانیه)"
                                colon={false}>
                                {getFieldDecorator("delay", {
                                    initialValue: this.props.initialData.delay ? this.props.initialData.delay : 0,
                                    rules: [{
                                        required: true, message: 'لطفا عدد وارد کنید',
                                        pattern: new RegExp(
                                            /^[0-9]+$/i
                                        )
                                    }]

                                })(
                                    <Input />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={6} offset={5}>
                            <Form.Item
                                {...formItemLayout}
                                label="حداکثر تعداد مشاهده"
                                colon={false}>
                                {getFieldDecorator("limit", {
                                    initialValue: this.props.initialData.limit ? this.props.initialData.limit : 0,
                                    rules: [{
                                        required: true, message: 'لطفا عدد وارد کنید',
                                        pattern: new RegExp(
                                            /^[0-9]+$/i
                                        )
                                    }]

                                })(
                                    <Input />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6} offset={5}>
                        <FormItem
                                {...formItemLayout}
                                label="وضعیت"
                                colon={false}>
                                {getFieldDecorator('status', {
                                    initialValue: this.props.initialData.status ? this.props.initialData.status : 0,
                                    rules: [],
                                })(
                                    <Select placeholder="وضعیت تبلیغ" style={{width: '200px'}}>
                                        <Select.Option value="0">غیرفعال</Select.Option>
                                        <Select.Option value="1">فعال</Select.Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6} offset={5}>
                            <Form.Item
                                {...formItemLayout}
                                label="مدت زمان کوکی(تکرار پس از چند ساعت)"
                                colon={false}>
                                {getFieldDecorator("repeat", {
                                    initialValue: this.props.initialData.repeat ? this.props.initialData.repeat : 0,
                                    rules: [{
                                        required: true, message: 'لطفا عدد وارد کنید',
                                        pattern: new RegExp(
                                            /^[0-9]+$/i
                                        )
                                    }]

                                })(
                                    <Input />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>

                    <Col span={11} offset={11}>


                            <FormItem
                                {...formItemLayout}
                                label={"تگ آلت"}
                                colon={true} >
                                {getFieldDecorator('alt', {
                                    initialValue: this.props.initialData.alt ? this.props.initialData.alt : null,
                                    rules: [{
                                        required: true,
                                        message: 'تگ آلت: ',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                    <FormItem>
                        <div className="btn-container">
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            >
                                {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                            </Button>
                        </div>
                    </FormItem>
                </Form>
            </div>
        )
    }
}
AdsModalForm.defaultValue = {
    initialData: {}
}

export default Form.create()(AdsModalForm);



// WEBPACK FOOTER //
// ./src/containers/AdsModal/form.js